/* eslint-disable no-undef */ /* eslint-disable no-unused-vars */

<!-- Componente utilizado para Para menu superior do projeto. -->

<template>
  <div
    class="topbar d-flex flex-row justify-content-between align-items-center no-print"
  >
    <div
      class="d-flex flex-row justify-content-between align-items-center flex-fill"
    >
      <div class="bar-content">
        <div class="d-flex flex-row align-items-center">
          <div>
            <LogoEyecare class="logo" />
          </div>
          <ClinicSelect />
          <!-- <LanguageSwitcher/> -->
        </div>
        <AttendanceFileProcess />
      </div>
    </div>
    <!--<div v-if="userHasPermission('EstNovaSol1') && showFeature('Solicitação de estoque')">
      <b-dropdown variant="link" class="dropdown-stock-request" toggle-class="text-decoration-none" no-caret>
          <template #button-content>
            <WarehouseRequest class="" />
          </template>

          <b-dropdown-item @click="openStockRequestModal">
            Fazer Solicitação de Produtos/Kits
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link to="/solicitacao-estoque">
              Histórico das minhas solicitações
            </router-link>
          </b-dropdown-item>
        </b-dropdown>
    </div> -->
    <div v-if="showCallPanel()" class="help d-flex align-items-center">
      <CallPanelIcon />
    </div>

    <div v-show="showPatientDocument" class="help">
      <DocumentFileProcess
        :changeShowPatientDocument="changeShowPatientDocument"
      />
    </div>

    <div v-show-feature="'novas-aplicacoes'" class="help">
      <NewFeatureWidget />
    </div>

    <div
      class="help"
      v-if="user?.type === 'DOCTOR_MANAGER' || user?.type === 'DOCTOR'"
    >
      <a
        href="https://conteudo.eyecarehealth.com.br/pt-br/programadeindicacao"
        target="_blank"
      >
        <Icon tooltip="Quem indica cresce junto!">
          <Notice />
        </Icon>
      </a>
    </div>
    <div v-show-feature="'zendesk'" class="help">
      <SupportChatWidget />
    </div>
    <div v-show-feature="'featureRequest'" class="help">
      <FeatureRequestWidget />
    </div>
    <div class="help">
      <Notification id="beamerButton" />
    </div>
    <div class="help d-flex align-items-center">
      <Help />
    </div>
    <div v-if="hasOrientationsPermission()" class="help d-flex align-items-center" @click="ShowOrientationsButton" title="Exibir orientações">
      <Orientations style="fill: #7F91D2"/>
    </div>
    <div
      class="user d-flex align-items-center"
      :class="{ open: dropdownOpened }"
      v-click-outside="clickOutside"
    >
      <div
        class="d-flex flex-row align-items-center pointer"
        @click="toggleDropdown"
      >
        <Avatar size="40" class="mr-3" :src="user?.picture" />
        <p class="name" v-if="user !== null">
          {{ (user.gender === null || user.gender === 'ND') ? '' : user.gender === 'M' ? 'Dr. ' : 'Dra. '
          }}{{ user.name }}
        </p>
        <ChevronDown class="icon-dropdown" />
      </div>

      <div class="dropdown">
        <div v-if="showDigitalSignature()" class="dropdown-item">
          <span v-b-modal.signature>
            <Key class="icon stroke" />
            Assinatura Digital
          </span>
          <div
            v-if="certActive"
            style="float: right"
            class="custom-control custom-switch"
          >
            <input
              type="checkbox"
              class="custom-control-input"
              id="checkboxAuth"
            />
            <label
              @click="enableSing"
              class="custom-control-label"
              for="checkboxAuth"
            />
          </div>
        </div>
        <div
          v-if="showPersonalData()"
          @click="goTo({name: 'myPersonalData', params: {professionalId: user.id}})"
          class="dropdown-item"
        >
          <User class="icon stroke" /> Dados pessoais
        </div>
        <div
          v-can="'Configurações da clínica'"
          @click="goTo('/configuracoes-da-clinica')"
          class="dropdown-item"
        >
          <Clinic class="icon fill" /> Configurações da clínica
        </div>
        <div
          v-can="'Configurações da agenda'"
          @click="goTo('/agenda/configuracoes')"
          class="dropdown-item"
        >
          <Calendar class="icon fill" /> Configurações da agenda
        </div>

        <div
          v-can="'Configurações da consulta'"
          v-if="showAttendanceConfig()"
          @click="goTo('/configuracoes-da-consulta')"
          class="dropdown-item"
        >
          <Clipboard class="icon stroke" /> Configurações da consulta
        </div>

        <div
          @click="goTo('/configuracoes-do-centro-cirurgico')"
          class="dropdown-item"
          v-if="showFeature('Centro cirúrgico')"
          v-can="'CenCirurg1'"
        >
          <Surgical class="icon surgical" /> Config. do centro cirúrgico
        </div>

        <div
          v-if="showPublicSchedule()"
          v-can="'AgOnlCli1'"
          @click="goTo('/agendamento-online')"
          class="dropdown-item"
        >
          <Computer class="icon stroke" /> Agendamento online
        </div>

        <div
          v-if="showCallPanel()"
          @click="goTo('/painel-de-chamadas')"
          class="dropdown-item"
        >
          <TV style="fill: #525C7A" class="icon"/> Painel de chamadas
        </div>
        <div
          v-can="'Relatórios gerenciais'"
          @click="goTo('/relatorios-gerenciais')"
          class="dropdown-item"
        >
          <Report class="icon stroke" /> Relatórios gerenciais
        </div>
        <div v-if="false" @click="goTo('/')" class="dropdown-item disabled">
          <Settings class="icon stroke" /> Minhas preferências
        </div>
        <div
          v-if="showOnlending()"
          v-can="'RepMedRel1'"
          @click="goTo('/repasse_medico/relatorio_de_repasse')"
          class="dropdown-item"
        >
          <Money class="icon" /> Repasse médico
        </div>

        <div
          v-can="'FpProto1'"
          class="dropdown-item"
          @click="goTo('/protocolos')"
        >
          <Protocol class="icon stroke" /> Protocolos
        </div>
        <div
          v-if="showFeature('Painel de Vendas')"
          class="dropdown-item"
          @click="goTo('/painel-vendas/orcamentos')"
          v-can="'FpPaiVen1'"
        >
          <Graph class="icon stroke" /> Painel de Vendas
        </div>

        <div
          v-if="clinic.id === '221b7dba-7986-47ac-aaa1-ede896820dcb'"
          class="dropdown-item"
          @click="goTo('/admin')"
        >
          <Settings class="icon stroke" /> Admin
        </div>
        <div class="dropdown-item" @click="logout">
          <LogOut class="icon stroke" /> Sair
        </div>
      </div>
      <input type="hidden" id="verifyInstallation" value="true" />
      <select id="certId" style="display: none"></select>
    </div>
    <b-modal id="signature" hide-header hide-footer centered size="lg">
      <div
        class="header d-flex flex-row justify-content-between"
        style="text-align: center; display: inline !important"
      >
        <p
          class="title"
          style="
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #525c7a;
          "
        >
          Assinatura Digital
        </p>
        <Close
          class="close"
          style="width: 24px !important; margin-top: -22px"
          @click="$bvModal.hide('signature')"
        />
      </div>
      <hr />
      <div class="body" align="center">
        <h6
          class="mb-5 mt-5"
          style="
            color: #525c7a;
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            text-align: center;
          "
        >
          Selecione o certificado digital que você deseja utilizar para
          autenticar seus documentos na Eyecare.
        </h6>
        <b-row class="mb-3" style="text-align: left; padding-left: 23px">
          <b-col
            style="
              font-family: Nunito Sans;
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 150%;
              color: #525c7a;
            "
          >
            Certificados integrados
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-button
              @click="
                () => {
                  $bvModal.hide('signature')
                  loadCerts($bvModal, $loading.show())
                }
              "
              variant="default"
              style="
                background: #f4f5fb;
                border: 1px solid #d9dff2;
                box-sizing: border-box;
                border-radius: 8px;
                padding: 15px;
                font-family: Nunito Sans;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 150%;
                color: #525c7a;
              "
              >Certificados A1 / A3 / A5 instalados em sua máquina
              <svg
                style="margin-left: 40px"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13L7 7L1 1"
                  stroke="#525C7A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="mb-3" style="text-align: left; padding-left: 23px">
          <b-col
            style="
              font-family: Nunito Sans;
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 150%;

              color: #525c7a;
            "
          >
            Certificados em nuvem
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-button
              @click="
                () => {
                  $bvModal.hide('signature')
                  const isLoading = $loading.show()
                  loadCertsCloud($bvModal, isLoading)
                }
              "
              variant="default"
              style="
                background: #f4f5fb;
                border: 1px solid #d9dff2;
                box-sizing: border-box;
                border-radius: 8px;
                padding: 15px;
                font-family: Nunito Sans;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 150%;
                color: #525c7a;
              "
              >Certificados contratados em nuvem
              <svg
                style="margin-left: 40px"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13L7 7L1 1"
                  stroke="#525C7A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      id="signature_cloud_select"
      hide-header
      hide-footer
      centered
      size="lg"
    >
      <div
        class="header d-flex flex-row justify-content-between"
        style="text-align: center; display: inline !important"
      >
        <p
          class="title"
          style="
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #525c7a;
          "
        >
          <span
            @click="
              $bvModal.hide('signature_cloud_select')
              $bvModal.show('signature')
            "
            ><svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
              tabindex="0"
              style="float: left; margin-top: 10px; margin-right: -10px"
            >
              <path
                d="M7 13L1 7L7 1"
                stroke="#7F91D2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
          Assinatura em nuvem
        </p>
        <Close
          class="close"
          style="width: 24px !important; margin-top: -22px"
          @click="$bvModal.hide('signature_cloud_select')"
        />
      </div>
      <hr />
      <div class="body" align="center">
        <h4
          class="mt-5"
          style="color: #0c1d59; font-weight: 600; text-align: center"
        >
          Serviços em nuvem vinculados ao seu CPF
        </h4>
        <h6
          class="mb-5"
          style="
            color: #525c7a;
            font-weight: 600;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
          "
        >
          Escolha qual serviço você deseja utilizar:
        </h6>
        <b-row class="mb-3" style="text-align: left; padding-left: 23px">
          <b-col
            style="
              font-family: Nunito Sans;
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 150%;

              color: #525c7a;
            "
          >
            Escolha o serviço
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-button
              v-for="(cert, index) in certsCloud"
              :key="index"
              class="mb-2"
              variant="default"
              @click="setSignatureCloud(cert)"
              style="
                background: #f4f5fb;
                border: 1px solid #d9dff2;
                box-sizing: border-box;
                border-radius: 8px;
                padding: 15px;
                font-family: Nunito Sans;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 150%;
                color: #525c7a;
                width: -webkit-fill-available;
                margin-left: 14px;
                margin-right: 14px;
                text-align: left;
              "
              >{{ cert.name + ' (' + cert.provider + ')' }}
              <svg
                style="float: right; margin-top: 5px"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13L7 7L1 1"
                  stroke="#525C7A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="signature_select" hide-header hide-footer centered size="lg">
      <div
        class="header d-flex flex-row justify-content-between"
        style="text-align: center; display: inline !important"
      >
        <p
          class="title"
          style="
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #525c7a;
          "
        >
          <span
            @click="
              $bvModal.hide('signature_select')
              $bvModal.show('signature')
            "
            ><svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
              tabindex="0"
              style="float: left; margin-top: 10px; margin-right: -10px"
            >
              <path
                d="M7 13L1 7L7 1"
                stroke="#7F91D2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
          Assinatura Digital
        </p>
        <Close
          class="close"
          style="width: 24px !important; margin-top: -22px"
          @click="$bvModal.hide('signature_select')"
        />
      </div>
      <hr />
      <div class="body" align="center">
        <h4
          class="mt-5"
          style="color: #0c1d59; font-weight: 600; text-align: center"
        >
          Certificados instalados
        </h4>
        <h6
          class="mb-5"
          style="
            color: #525c7a;
            font-weight: 600;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
          "
        >
          Escolha quais dos certificados instalados você deseja utilizar:
        </h6>
        <b-row class="mb-3" style="text-align: left; padding-left: 23px">
          <b-col
            style="
              font-family: Nunito Sans;
              font-style: normal;
              font-weight: bold;
              font-size: 16px;
              line-height: 150%;

              color: #525c7a;
            "
          >
            Escolha qual certificado deseja utilizar
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col>
            <b-button
              v-for="(cert, index) in certs"
              :key="index"
              class="mb-2"
              variant="default"
              @click="setSignature(cert)"
              style="
                background: #f4f5fb;
                border: 1px solid #d9dff2;
                box-sizing: border-box;
                border-radius: 8px;
                padding: 15px;
                font-family: Nunito Sans;
                font-style: normal;
                font-weight: 600;
                font-size: 16px;
                line-height: 150%;
                color: #525c7a;
                width: -webkit-fill-available;
                margin-left: 14px;
                margin-right: 14px;
                text-align: left;
              "
              >{{ cert.subjectName + ' (issued by ' + cert.issuerName + ')' }}
              <svg
                style="float: right; margin-top: 5px"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13L7 7L1 1"
                  stroke="#525C7A"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="signature_finish" hide-header hide-footer centered size="lg">
      <div
        class="header d-flex flex-row justify-content-between"
        style="text-align: center; display: inline !important"
      >
        <p
          class="title"
          style="
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #525c7a;
          "
        >
          <span
            @click="
              $bvModal.hide('signature_finish')
              $bvModal.show('signature')
            "
            ><svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
              tabindex="0"
              style="float: left; margin-top: 10px; margin-right: -10px"
            >
              <path
                d="M7 13L1 7L7 1"
                stroke="#7F91D2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
          Assinatura Digital
        </p>
        <Close
          class="close"
          style="width: 24px !important; margin-top: -22px"
          @click="$bvModal.hide('signature_finish')"
        />
      </div>
      <hr />
      <div class="body" align="center">
        <div class="form-group">
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="certName"
            readonly
          />
        </div>
        <div style="text-align: left" class="form-group">
          <label>Tempo de uso</label>
          <select id="timeUse" class="form-control">
            <option value="12">Expirar login em 12h</option>
            <option value="24">Expirar login em 24h</option>
            <option value="6">Expirar login em 6h</option>
            <option value="1">Expirar login em 1h</option>
          </select>
        </div>
        <div style="text-align: left" class="form-group">
          <label>Seu CPF</label>
          <input
            autocomplete="off"
            type="text"
            class="form-control"
            id="certCpf"
            placeholder="000.000.000-00"
          />
        </div>
        <div style="text-align: left" class="form-group">
          <label>Token de autenticação</label>
          <input
            autocomplete="off"
            type="password"
            class="form-control"
            id="certToken"
            placeholder="0000000"
          />
        </div>
        <b-row class="mb-3" align="right">
          <b-col>
            <b-button variant="primary" @click="autenticCert"
              >Autenticar certificado</b-button
            >
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal id="signature_install" hide-header hide-footer centered size="lg">
      <div
        class="header d-flex flex-row justify-content-between"
        style="text-align: center; display: inline !important"
      >
        <p
          class="title"
          style="
            font-weight: 600;
            font-size: 18px;
            line-height: 28px;
            color: #525c7a;
          "
        >
          <span
            @click="
              $bvModal.hide('signature_install')
              $bvModal.show('signature')
            "
            ><svg
              width="8"
              height="14"
              viewBox="0 0 8 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="button"
              tabindex="0"
              style="float: left; margin-top: 10px; margin-right: -10px"
            >
              <path
                d="M7 13L1 7L7 1"
                stroke="#7F91D2"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </svg>
          </span>
          Assinatura Digital
        </p>
        <Close
          class="close"
          style="width: 24px !important; margin-top: -22px"
          @click="$bvModal.hide('signature_install')"
        />
      </div>
      <hr />
      <div class="body" align="center">
        <h4
          class="mt-5"
          style="color: #0c1d59; font-weight: 600; text-align: center"
        >
          Instalar Web PKI
        </h4>
        <h6
          class="mb-5"
          style="
            color: #525c7a;
            font-weight: 600;
            font-size: 16px;
            line-height: 28px;
            text-align: center;
          "
        >
          É necessário instalar a extensão Web PKI para utilizar essa opção.
          Siga todos os passos indicados pela empresa parceira.
        </h6>
        <b-row class="mb-3">
          <b-col>
            <b-button variant="primary" @click="goInstall"
              >Click aqui para instalar</b-button
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <svg
              width="99"
              height="32"
              viewBox="0 0 99 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect width="98.6791" height="32" fill="url(#pattern0)" />
              <defs>
                <pattern
                  id="pattern0"
                  patternContentUnits="objectBoundingBox"
                  width="1"
                  height="1"
                >
                  <use
                    xlink:href="#image0"
                    transform="translate(0 -0.460465) scale(0.0015083 0.00465116)"
                  />
                </pattern>
                <image
                  id="image0"
                  width="663"
                  height="447"
                  xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAApcAAAG/CAMAAAA6pQxlAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAGxQTFRF////yeX1kszqabnjXLLgu9/y8fn8d7/lM5/YJpnWrdnwQKXbTqze1uz3hMXooNLt5PL6ms/sxeT0Ua3eYLThi8npt93x8fj8Q6fbfcLmqNbv4vH61Ov3NKDZbrvk8PHyw8XJ4eLkDxgph4uUmHzT+AAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAx5SURBVHja7d1rW5voFgZgHeshte3o1GO13af//x/31RoCMawFvIGAet+fZkxAJE95ElhJjo4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAeIOO/zr59MfJX6dnc28M/HZ8frFqOvk89xbB8afVjkvJZFZnJ6tWX77OvWV8YF8vVoELh0zm8nmV+Db31vFBpbEUTOYRl/iaKufwzi5XXbz44eDOO2O5+jL3NvLhHHfHcrX6e+6t5KP51CeXF3NvJR/MVZ9YeunDgX3rl0vPMDmo7hfjL67m3lA+kq89Y+mVD4fUs8YVOQfVt8YVOQfUu8YVOQfUu8YVOQfUv8YVOQczoMYVOQczoMYVOQczpMYVOQcyqMYVOQcyqMYVOQcyrMYVOQcxsMYVOQcxsMYVOQcxtMYVOQcQ1vjFF0XObMIaP/lbkTObsMY/x+/5uZp7o3nv4lfjZ3FkFTkTC2v8U3KbImdi2TExPpZezb3ZvG959MJP0lLkTCqv6vP0VphKWON/Pu3yVJEzh7jGXz5TMLxZkTOhsMYvX24/iW5X5EworPHzl9vjj7a+mnvTeb/iGj99ucOZIufwwhrffNBlOLuhyJlMWOMn1T3C2Q1FzlTiGt98/mo8u6HImUg8qV5/iW54SFXkTCTM3Kf6PnF2r+befN6nuMYbHX3c504wnn6HwnB2Q5EzibDGL5v3ir9v6mruP4D3KK7xrW8ojWc3FDkTiGt863sg40s+ipwJhDX+6lvNwtkNRc744ho/375jPLuhyBldXOOn23eML/kockYXf/zL63uGsxuKnLHFNX7y+q7x7IYiZ2Rxje98Z24cYUXOyOIaPxtw36u5/wzel0HHwPjYqsgZ1aCoxbMbipxRDavmi0H3hkJxjV+23T2e3VDkjCiu8W9td49nNxQ5I4pr/Gvb3ePZDUXOeOIav2hfIJ7dUOSMJq7x8/YF4tkNRc5o4ho/bV8gnt1Q5Iwl+YazaJF4dkORM5K4xk+iReLZDUXOSOIa/xwtkhxir+b+c3gfkoydhQvFWVbkjCKu8S8jL9TDeiXXxXf7Z9VHutZW329u7+4newyyrX64efzx1LkrVv+03/z8c7Oi28K9dTPZn50qOvTFsxv7Fflic/nH49PRNDq3+tc/0aJ5Lu8f6o0v+b3z5bLwqWI8u7FXkS87l6ufP6Z5EHps9W2waJrL++9pLJecy7iRL7PF4tmNvYp84blcraYJZp+tfmxfNM1lHcvvxb93plzGNf4tWyye3diryBefy9XzFA9Cr61u3ylZLh/rWN6X/95ZcpnU+NdsuWR2Y58iX34uJ3mUem31z9ZsJbnsjOWCcxnX+EW+YDy7sU+RLz+Xkxww+211616Jc3ldJ/p5n987Sy7jGj/PF4xnN/Yp8vFyeZ1J17p63F3gpiMde0q2+ld9oudXttE7ufzRHcujp+3f1b4DJnqtl0pq/DRfMpnd2KPIx8tl+S9vfar2tHkJ8WvwertlW33/uMnXkI2uY9n/CJ/tgMOKa7zzgY1nN/Yo8sXmsj4T+H3oanvIt/pXdWvbs8Rgoxvn0/sf75aTy7jGT7oWjWc39ijy5eby6HaPNXfJt/ou27D224piuZxcJjX+eY9ly4t8wbm822PNXfKtvh+cy/s6lkOeDi8ml0mNn3UuHB9ry4t8vYLH/F5Pc+RynzV36Vj30Fx2XeYp2wEHtFe0klBflW7QevmOUxPVwyiXrbeVxnIxudyvio/3WrpddT4mv9d1vP/ksnk+feCpx6Xkcs8jXjy7UVzk1S7NT21UL1BbXp/KZY/LPGU74HDiGr/ss3g8u1Fc5NWR8C6917qn2s7nyWV9mWdoLJeSy6TGv/VZPpndKC3y5Jnj7v67SVbwYXPZuMwzeFp0IblMavxrn+WT2Y3iIk8it5GF96Pnss/Vx8IdcDBxjV/0W0E8u1Fc5OuKfmj86Prmt0YnVfu+reyny2XVj1OMMYyWy/p8ekEsF5LL5PX0eb81JLMbpUX+uF6+EcOXC4CNyxbVlZe2npoul9WpgmGnXvrJt/op27Ct28ou8/TcAYeSvGw57beGZHajtMh3TwE978RhnZDWMYbJcrkpyLuhq+0h3+of2YY1byu8zNNvBxxMfJqn94Maz26UFvnuc8fbnRSu73KTLT9uLp/uNoNuDwUr7v1Xt251/d6xjo1unE8vqvFl5DJ5Nd05s1H5K15HYZFX14Lrw2O1szfHqeQqZI9J1+RA0rXo9maMKctlPWHXMefWjOUbfn6Z1HjnzEYlOdNUWuTrg8Nmmmzz5GqT1GqAovUZ1NS5nOLZZTYXfNuYSO6YC37c3tK3+no8qfGr3iu5HGMlW6prOdX/b04T/3z9k9b9Pm0uZ3yf7ir4h7jJ0uPOxg4O5hJymdT4gENdcgq0sMhfp64up6pBXyd3y6S5vJ7qEzf6ve8s3ejvLQsMzdcScpnU+IBEjZPupuohWh8cnuoVVhW6bvqbdPFJcrl6nCiYvXLZ/sy2JY71fw48vC8hl0mN97rY072aq6LtevWqpr7auzlerP+3/QMoJn5+WfQyt9sIn2tQZ/G5OJgLyGVyoOs1s1EZ57DbtN6r68Nhs55eDhivDqivTP26Z/hF5z565DLa7p1Ybp1dHxbMBeQyyVOvmY1KcsmnsMi3zpo/NVf4csRIX/Z0v0832eeb37P7qrj+5zHP5xrEn9i1G8vyYC4gl0n/Hg9ZTzK7UVjkVe6emv/TiOrj+v/al57qes/zJpmH/lyDjk84bIll85znG3vfWVLjPWc2KsnsRlmR3zV3zvarzD9Fvj6eBm+Xne59utUxaNLPNSjf6O1tuy8K5vy5TGq858xGJXm7blmRPzf28brGv6+vEN82dl7wMmD69+nOME/UZ6Nf7ZOiYM6fy6TGe85sVJLZjcIiXy/8++rGusav11cnf1+bbsa2xfTv053iAvk4udz6p1oSzNlzmdR4jzfobktmN8qKvFHU6337VJ1Lf35V87ve5Vxwn43eaZCCYM6ey6TGe89sVJLZjbIirwqzrvHNqNdt/UooWPjj5nLnic3wYM6ey6TGe89sVJLZjbIi/7HZO1WNb8aMHrpe9nzcXLY8324G83bIuubKZVbjV4PXlsxuFBV59QzyR13jR3WRP4QPwx8fNpdtG90M5v47YHpJjRdU77dR11bvntt1jf95AVwVeTWfGZ2tkcumRjD33wHTS2q84Ag37tH3aPNq5+a6Om7+9nL68KF6BKNdJ5db6mDuv67JZUEaMrNRGTfm9RWd9Zns++YPq/cURFdA5HLb/ZA1z5zLpMYHzWz0WF9RkW9dfKymtO+2fhieRJTL4PYx1jWx5Pg2aGajksxuFBX59tXi6hTHz+YPf3UuW/B784dlvs+/3GOj31IusxofNLNRyWY3iop8aw1VYz82fxhepH6Pnxe8x0a/pVwmtTtwZqOSzG4UFXlzWmNzZNwq8nDPTT+3sdDr428/l0mND5zZqCSzG0VF/quxfH2l4qHx03Dw6/19H8UeG928fYx1TSqr8YEzG5VsdqOkyFvePHHUKNLoLVi/TfP9PY254KXOuZXk8tXX9wTf39MySn0zUJ8/JKnxwTMblWR2o6TIGy98Gtd1nuuf3vRZNJE/hLlJ54KHL7pPLvvtrJZ/if2W69rf25IaHzyzUUlmN0qK/L5euvkmwLrI42PWG/9+yOGLvpdcZjU+eGajks1ulBT5JoFbhV0XefxhLG/8+3SHL/pecpnV+FXxjk1mN0qKfPPhJ1vjGXWRx29KfOPfPz580feSy6TG9/j+vGR2oyTtm2fg2wfG6jAav+yZOJeTfw7M8EXfSS6zGt/j+0ZHXm11rvJVAHt8ZO+kuXyc5M3jR3J5dPT5U6xkZqOSrLbg2mb1tvHb9h8np2qmymXHu2X3JJcAAAAAAAAAAAAAAAAAAIv2r3/P5D9z/+Us2b//O5P/zf2Xs2RyyRLJJUsklyyRXLJEcskSySVLJJcskVyyRHLJEsklSySXLJFcskRyyRLJJUsklyyRXLJEcskSySVLJJcskVyyRHLJEsklS+T94wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAALn/A0l9tQZ2BgtRAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTA5LTIwVDEwOjE5OjUzLTAzOjAwCK8h4wAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0wOS0yMFQxMDoxOTo1My0wMzowMHnymV8AAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"
                />
              </defs>
            </svg>
          </b-col>
        </b-row>
        <b-row class="mt-4 mb-3">
          <b-col
            style="
              font-family: Nunito Sans;
              font-style: normal;
              font-weight: 600;
              font-size: 14px;
              line-height: 150%;
              text-align: center;
              color: #525c7a;
            "
          >
            Ao clicar no botão você será redirecionado para uma página externa.
          </b-col>
        </b-row>
      </div>
    </b-modal>
    
    <!--<StockRequestModal
        ref="stockRequestModal"
        v-if="userHasPermission('EstNovaSol1')"
    />-->
  </div>
</template>
<script>
import {
  showDigitalSignature,
  showPersonalData,
  showAttendanceConfig,
  showCallPanel,
  showPublicSchedule,
  showOnlending,
  showFeature
} from '@/utils/permissionsHelp'
import { getCurrentClinic, getPermissions, userHasPermission } from '@/utils/localStorageManager'
import { checkCloudAuth } from '@/utils/certificateHelper'

import { LacunaWebPKI } from 'web-pki'
import $ from 'jquery'
import '../utils/jquery.mask.js'

export default {
  name: 'Topbar',
  metaInfo: {
    title: 'Eyecare - Configurações da Agenda'
  },
  components: {
    AttendanceFileProcess: () =>
      import('@/components/Document/AttendanceFileProcess'),
    Avatar: () => import('@/components/General/Avatar'),
    Calendar: () => import('@/assets/icons/calendar.svg'),
    CallPanelIcon: () => import('@/components/CallPanelIcon'),
    ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
    Clinic: () => import('@/assets/icons/clinic.svg'),
    ClinicSelect: () => import('@/components/ClinicSelect'),
    Clipboard: () => import('@/assets/icons/clipboard.svg'),
    Close: () => import('@/assets/icons/close.svg'),
    Computer: () => import('@/assets/icons/computer.svg'),
    Help: () => import('@/components/Help/Help'),
    Icon: () => import('@/components/General/Icon'),
    Key: () => import('@/assets/icons/key.svg'),
    LogoEyecare: () => import('@/assets/icons/logo-eyecare-solid.svg'),
    LogOut: () => import('@/assets/icons/log-out.svg'),
    Money: () => import('@/assets/icons/money.svg'),
    Notice: () => import('@/assets/icons/notice.svg'),
    Notification: () => import('@/assets/icons/notification.svg'),
    DocumentFileProcess: () =>
      import('@/components/Document/DocumentFileProcess'),
    Report: () => import('@/assets/icons/file.svg'),
    Protocol: () => import('@/assets/icons/protocol.svg'),
    Settings: () => import('@/assets/icons/settings.svg'),
    Surgical: () => import('@/assets/icons/surgical.svg'),
    TV: () => import('@/assets/icons/tv.svg'),
    Orientations: () => import('@/assets/icons/orientations.svg'),
    User: () => import('@/assets/icons/user.svg'),
    Graph: () => import('@/assets/icons/graph.svg'),
    // WarehouseRequest: () => import('@/assets/icons/stock-request.svg'),
    NewFeatureWidget: () =>
      import('@/modules/newFeatures/components/NewFeatureWidget'),
    FeatureRequestWidget: () =>
      import('@/modules/featureRequests/components/FeatureRequestWidget'),
    SupportChatWidget: () => import('@/components/General/SupportChatWidget'),
    // LanguageSwitcher: () => import('@/components/language/LanguageSwitcher'),
    // StockRequestModal:() => import('@/components/Warehouse/StockRequests/StockRequestModal'),
  },
  mounted() {
    if (localStorage.getItem('singItemAutentic')) {
      this.certActive = true
    }
    this.certs = JSON.parse(localStorage.getItem('certsData'))
    this.certsCloud = JSON.parse(localStorage.getItem('certsCloudData'))
    this.verifyButton()
    this.loadUserData()

    this.eventHub.$on('userUpdated', async () => {
      this.loadUserData()
    })

    this.eventHub.$on('clinicUpdated', async clinicData => {
      this.clinics = this.clinics.map(clinic => {
        if (clinic.value === clinicData.id) {
          clinic.name = clinicData.name
        }

        return clinic
      })
    })
  },

  data() {
    const clinic = getCurrentClinic()

    return {
      clinic,
      user: null,
      dropdownOpened: false,
      clinicSelected: null,
      clinics: [],
      certs: [],
      certsCloud: [],
      certActive: false,
      permissions: clinic.permissions,
      showPatientDocument: false
    }
  },
  methods: {
    showDigitalSignature,
    showPersonalData,
    showAttendanceConfig,
    showCallPanel,
    showPublicSchedule,
    showOnlending,
    showFeature,
    userHasPermission,
    verifyButton() {
      if (localStorage.getItem('singItemAutentic')) {
        var aux = JSON.parse(localStorage.getItem('singItemAutentic'))
        if (aux.active === true) {
          setTimeout(() => {
            if (document.getElementById('checkboxAuth'))
              document.getElementById('checkboxAuth').checked = true
          }, 1000)
        }
      }
    },
    enableSing() {
      if (localStorage.getItem('singItemAutentic')) {
        var aux = JSON.parse(localStorage.getItem('singItemAutentic'))
        if (aux.active === true) {
          aux.active = false
        } else {
          aux.active = true
        }
        localStorage.removeItem('singItemAutentic')
        localStorage.setItem('singItemAutentic', JSON.stringify(aux))

        window.location.reload()
      }
    },
    goInstall() {
      window.open('https://get.webpkiplugin.com/', '_blank')
    },
    loadCertsCloud(modal, load) {
      const user = localStorage.getItem('user')

      this.user = JSON.parse(user)
      this.api
        .discoverCerts(this.clinic.id)
        .then(res => {
          if (res.data.length > 0) {
            localStorage.setItem('certsCloudData', JSON.stringify(res))
            this.certsCloud = res.data
            modal.show('signature_cloud_select')
          } else {
            alert('Não foram encontrados serviços vinculados ao seu cpf')
          }
        })
        .catch(err => {
          console.log('Err', err)
        })
        .finally(() => load.hide())
    },
    loadCerts(modal, load) {
      var signatureStartForm = (() => {
        // eslint-disable-next-line no-undef
        var pki = new LacunaWebPKI()

        function init(modal, load) {
          setTimeout(() => {
            if ($('#verifyInstallation').val() === 'false') {
              console.log($('#verifyInstallation').val())
              modal.show('signature_install')
              load.hide()
            }
          }, 6200)
          pki.init({
            restPkiUrl: 'https://lacuna.dev.eyecarehealth.com.br/',
            ready: loadCertificates // As soon as the component is ready we'll load the certificates.
          })
        }

        // eslint-disable-next-line no-unused-vars
        function refresh() {
          loadCertificates()
        }

        var loadCertificates = () => {
          var certs1 = []
          pki
            .listCertificates({
              selectId: 'certId',
              selectOptionFormatter: function (cert) {
                if (new Date() <= new Date(cert.validityEnd)) {
                  certs1.push(cert)
                }
                return 1
              }
            })
            .success(() => {
              localStorage.setItem('certsData', JSON.stringify(certs1))
              this.certs = certs1
              load.hide()
              modal.show('signature_select')
            })
        }

        return {
          init: init
        }
      })()

      signatureStartForm.init(modal, load)
    },
    setSignature(item) {
      this.$bvModal.hide('signature_select')
      this.$bvModal.show('signature_finish')
      if (localStorage.getItem('singItem')) {
        localStorage.removeItem('singItem')
      }
      localStorage.setItem('singItem', JSON.stringify(item))
      setTimeout(() => {
        var s = document.getElementById('certName')
        s.value = item.subjectName + ' (issued by ' + item.issuerName + ')'
        var options = {
          onKeyPress: function (cpf, ev, el, op) {
            $('#certCpf').mask('000.000.000-000', op)
          }
        }

        $('#certCpf').mask('000.000.000-00#', options)
      }, 500)
    },
    setSignatureCloud(item) {
      if (localStorage.getItem('singItemCloud')) {
        localStorage.removeItem('singItemCloud')
      }
      localStorage.setItem('singItemCloud', JSON.stringify(item))
      // eslint-disable-next-line no-extend-native
      Date.prototype.addHours = function (h) {
        this.setHours(this.getHours() + h)
        return this
      }
      if (localStorage.getItem('singItemAutentic')) {
        localStorage.removeItem('singItemAutentic')
      }
      var time = 2
      localStorage.setItem(
        'singItemAutentic',
        JSON.stringify({
          cert: JSON.parse(localStorage.getItem('singItemCloud')),
          time: new Date().addHours(time),
          type: 2,
          active: true
        })
      )
      this.$bvModal.hide('signature_cloud_select')
      checkCloudAuth(this.user.id, item);
    },
    autenticCert() {
      // eslint-disable-next-line no-extend-native
      var cpf = document.getElementById('certCpf').value
      cpf = cpf.replace('.', '')
      cpf = cpf.replace('.', '')
      cpf = cpf.replace('-', '')

      var aux = JSON.parse(localStorage.getItem('singItem'))
      if (cpf === aux.pkiBrazil.cpf) {
        // eslint-disable-next-line no-extend-native
        Date.prototype.addHours = function (h) {
          this.setHours(this.getHours() + h)
          return this
        }
        if (localStorage.getItem('singItemAutentic')) {
          localStorage.removeItem('singItemAutentic')
        }
        var time = document.getElementById('timeUse').value
        localStorage.setItem(
          'singItemAutentic',
          JSON.stringify({
            cert: JSON.parse(localStorage.getItem('singItem')),
            time: new Date().addHours(time),
            type: 1,
            active: true
          })
        )
        this.$bvModal.hide('signature_finish')
        location.reload()
      } else {
        alert('Cpf não confere com o certificado selecionado, tente novamente.')
      }
    },
    loadUserData() {
      const user = localStorage.getItem('user')

      this.user = JSON.parse(user)

      this.clinics = this.user.clinics.map(clinic => {
        const clinicOption = { value: clinic.id, name: clinic.name }
        if (this.clinicSelected === null) {
          this.clinicSelected = clinicOption
        }

        return clinicOption
      })
    },
    toggleDropdown() {
      this.dropdownOpened = !this.dropdownOpened
    },
    goTo(path) {
      this.toggleDropdown()
      this.$router.push(path)
    },
    clickOutside() {
      if (this.dropdownOpened) {
        this.toggleDropdown()
      }
    },
    clinicSelect(option) {
      localStorage.setItem('clinic', JSON.stringify(option))
    },
    async logout() {
      try {
        await this.api.logout()
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('user')
        localStorage.removeItem('clinic')
        localStorage.removeItem('permissions')
        localStorage.removeItem('session_cloud_token')
        localStorage.removeItem('showOrientationsButton')
        window.location.href = '/login'
      } catch (err) {
        this.$toast.error(err.message)
      }
    },
    changeShowPatientDocument(status) {
      this.showPatientDocument = status
    },
    hasOrientationsPermission(){
      const permissions = getPermissions();
      // Permissão de visualizar e editar orientações
      const elementsToFind = ['OrConv1', 'OrConv2', 'OrCli1', 'OrCli2', 'OrPro1', 'OrPro2'];
      return permissions.some(permission => elementsToFind.includes(permission));
    },
    ShowOrientationsButton() {
      let showOrientationsButton = localStorage.getItem('show_orientations_button')

      if (showOrientationsButton !== null) {
        showOrientationsButton = JSON.parse(showOrientationsButton);
      } else {
        showOrientationsButton = false;
      }

      localStorage.setItem('show_orientations_button', !showOrientationsButton)

      window.dispatchEvent(new CustomEvent('toggle-orientations-button', {
        detail: {
          storage: JSON.parse(localStorage.getItem('show_orientations_button'))
        }
      }));
    },
    openStockRequestModal() {
      this.$bvModal.show('stock-request-modal');
    }
  }
}
</script>

<style lang="scss">
.topbar {
  height: 72px;
  border-bottom: 1px solid var(--neutral-200);
  padding: 0 24px;
  background-color: var(--neutral-000);
  position: relative;

  .dropdown-stock-request {
    a {
      color: #000;
      text-decoration: none;
    }
    
    svg {
      stroke: none !important;
    }
  }

  .bar-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .logo {
    width: auto;
    fill: var(--type-placeholder);
    padding-right: 24px;
    margin-right: 24px;
    border-right: 1px solid var(--neutral-200);
  }

  .multiselect-topbar {
    width: 100%;
    z-index: 1001;

    &.multiselect--active {
      /* width: 120%; */

      .multiselect__tags {
        border: 1px solid var(--neutral-000);
      }
    }
  }

  .help {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    border-left: 1px solid var(--neutral-200);
    padding-left: 24px;
    margin-left: 24px;
    cursor: pointer;
  }

  .user {
    height: 100%;
    border-left: 1px solid var(--neutral-200);
    padding-left: 24px;
    margin-left: 24px;
    position: relative;

    .pointer {
      cursor: pointer;
    }

    .name {
      font-size: 16px;
      font-weight: 400;
      color: var(--type-active);
      margin: 0 16px 0 0;
    }

    .icon-dropdown {
      width: 24px;
      height: 24px;
      transition: all 500ms;
      stroke: var(--neutral-600);
    }

    &.open {
      .icon-dropdown {
        stroke: var(--neutral-600);
        transform: rotate(180deg);
      }

      .dropdown {
        padding: 8px 0;
        max-height: 100vh;
        border-bottom: 1px solid var(--neutral-200);
        z-index: 9999;
      }
    }

    .dropdown {
      width: 350px;
      max-height: 0;
      overflow: hidden;
      position: absolute;
      top: 72px;
      right: -24px;
      background-color: var(--neutral-000);
      text-align: left;
      border-left: 1px solid var(--neutral-200);
      transition: all 500ms;
      z-index: 1001;

      .dropdown-item {
        padding: 10px 24px;
        cursor: pointer;
        font-size: 1rem;

        &.disabled {
          cursor: none;

          &:hover {
            background-color: var(--neutral-000);
          }
        }

        .icon {
          width: 23px;
          height: 23px;
          margin-right: 24px;

          &.fill {
            fill: var(--type-active);
          }

          &.stroke {
            stroke: var(--type-active);
          }
          &.surgical {
            path {
              fill: var(--type-active);
            }
          }
        }

        &:hover {
          background-color: var(--neutral-100);
        }
      }
    }
  }
}
</style>
